import React from 'react';

import ConfirmableButton from './ConfirmableButton.js'
import DynamicallyPopulatedDropdown from './DynamicallyPopulatedDropdown.js'

export default class LevelSelector extends React.Component {
  render() {
    let loadLevelButton = ''
    if (this.props.selectedLevelName !== undefined) {
      loadLevelButton = <ConfirmableButton
        buttonText='Load Selected Level'
        confirmationText='This will override unsaved changes, are you sure?'
        confirmationAction={this.props.loadLevel}
      />
    }

    return(
      <div className='level-selector'>
        <span>Load Map</span>
        <DynamicallyPopulatedDropdown
          selectOptions={this.props.selectOptions}
          onSelectChange={this.props.updateLevelSelection}
          value={this.props.selectedLevelName}
        />
        {loadLevelButton}
      </div>
    );
  }
}
